import { render, staticRenderFns } from "./PronosticoAireControl.vue?vue&type=template&id=32d970e6&scoped=true"
import script from "./PronosticoAireControl.vue?vue&type=script&lang=ts"
export * from "./PronosticoAireControl.vue?vue&type=script&lang=ts"
import style0 from "./PronosticoAireControl.vue?vue&type=style&index=0&id=32d970e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d970e6",
  null
  
)

export default component.exports